// Polyfills needed for @solana/web3.js in CRA browser context
import { Buffer } from "buffer";
if (typeof window !== "undefined") {
  window.Buffer = window.Buffer || Buffer;
  // process may be expected by some deps
  // eslint-disable-next-line no-undef
  window.global = window.global || window;
}
